"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsRoleTeam = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var PermissionLevelDisplay_1 = require("./PermissionLevelDisplay");
var RoleTeamAvatar = function () {
    return React.createElement(react_1.Avatar, { icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faStar }), color: "white" });
};
var RoleTeamName = function (_a) {
    var roleTeam = _a.roleTeam;
    return (React.createElement(react_1.Flex, { textTransform: "capitalize", fontWeight: "600" }, roleTeam.roleTeamName));
};
var PermissionsRoleTeam = function (_a) {
    var roleTeam = _a.roleTeam;
    return (React.createElement(react_1.Flex, { justify: "space-between" },
        React.createElement(react_1.Stack, { align: "center", direction: "row", spacing: 4 },
            React.createElement(RoleTeamAvatar, null),
            React.createElement(RoleTeamName, { roleTeam: roleTeam })),
        React.createElement(PermissionLevelDisplay_1.PermissionLevelDisplay, { permissionLevel: roleTeam.permissions.effectivePermission, showIcon: true })));
};
exports.PermissionsRoleTeam = PermissionsRoleTeam;
